export default {
  mapQuotes(quotesResponse, images) {
    return quotesResponse.map(quote => {
      const imageUrl = this.imageForQuote(quote, images);
      return { ...quote, imageUrl };
    });
  },

  imageForQuote(quote, images) {
    switch (quote.productCode) {
      case 'COC':
        return images.insuranceQuotesCostAssist;
      case 'CAC':
        return images.insuranceQuotesCashAssist;
      case 'DAC':
        return images.insuranceQuotesDebtAssist;
      case 'EC_D':
        return images.insuranceQuotesEduAssist;
      case 'TAC':
        return images.insuranceQuotesTaxAssist;
      default:
        break;
    }
  },
};
